import { createSelector } from "reselect";
import { RootState } from "../reducers";
import { mapCaseAndDistributionListToCaseFollows } from "./utils";

export const selectUserCaseFollows = (state: RootState) =>
  state.userCaseFollows.userCaseFollows;

export const selectUserCaseFollowsIncluded = (state: RootState) =>
  state.userCaseFollows.included!;

export const selectUserCaseFollowsMeta = (state: RootState) =>
  state.userCaseFollows.meta;

export const selectUserCaseFollowsRecordCount = createSelector(
  selectUserCaseFollowsMeta,
  meta => (meta ? meta.recordCount : 0),
);

export const selectMappedUserCases = createSelector(
  selectUserCaseFollows,
  selectUserCaseFollowsIncluded,
  mapCaseAndDistributionListToCaseFollows,
);
